
import React, { Component } from "react";
import { Avatar, Image } from "antd";
import { BankOutlined, InfoCircleFilled } from "@ant-design/icons";
import PropTypes from "prop-types";
import moment from "moment";
import { FormatDataCustomerJson } from "../../helpers/formatDataJson";
import { BankData } from "../../Data/BankData";
import KBizPhoneIcon from "../../assets/images/icon/highlight-2.png";

export class TransferManual extends Component {
  constructor(props) {
    super(props);
    this.state = {
      secondsLeft: 300, // 5 นาที = 300 วินาที
    };
    this.timer = null;
  }

  componentDidMount() {
    this.startCountdown();
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  startCountdown = () => {
    const { rejectedManual, dataMember } = this.props;

    this.timer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.secondsLeft <= 1) {
          clearInterval(this.timer);

          if (typeof rejectedManual === "function") {
            setTimeout(() => {
              rejectedManual(true, dataMember);
            }, 1000);
          }

          return { secondsLeft: 0 };
        }
        return { secondsLeft: prevState.secondsLeft - 1 };
      });
    }, 1000);
  };

  formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    const displayMins = mins < 10 ? `0${mins}` : mins;
    const displaySecs = secs < 10 ? `0${secs}` : secs;
    return `${displayMins} : ${displaySecs}`;
  };

  render() {
    const { dataTranfer, t, dFormat = 'th' } = this.props;
    const { secondsLeft } = this.state;

    if (!dataTranfer) return null;

    const styles = {
      container: { width: "100%", maxWidth: "550px", backgroundColor: "#ffffff", padding: "24px", display: "flex", flexDirection: "column", boxSizing: "border-box", fontFamily: "inherit" },
      notifyText: { fontSize: "14px", fontWeight: "500", color: "#374151", textAlign: "center", lineHeight: "1.6", marginBottom: "24px" },
      countdownText: { fontSize: "12px", color: secondsLeft === 0 ? "#ef4444" : "#ff4d4f", fontWeight: "600", textAlign: "center", marginBottom: "24px" },
      title: { fontSize: "20px", fontWeight: "700", color: "#1f2937", marginTop: 0, marginBottom: "24px", textAlign: "left" },
      grid: { display: "flex", flexWrap: "wrap", gap: "20px", marginBottom: "16px" },
      col: { flex: "1 1 230px", display: "flex", flexDirection: "column", textAlign: "left" },
      label: { fontSize: "14px", fontWeight: "700", color: "#1f2937", marginBottom: "8px" },
      card: { display: "flex", alignItems: "center", gap: "12px", backgroundColor: "#f8f9fa", border: "1px solid #f3f4f6", padding: "16px", borderRadius: "12px", height: "84px", boxSizing: "border-box" },
      avatarFrom: { width: "44px", height: "44px", borderRadius: "50%", backgroundColor: "none", justifyContent: "center", border: "1px solid rgb(5, 150, 105)", color: "#059669", fontSize: "18px", display: "flex", alignItems: "center", justify: "center", flexShrink: 0, boxSizing: "border-box" },
      avatarTo: { backgroundColor: "#138546", color: "#ffffff", flexShrink: 0 },
      infoBox: { display: "flex", flexDirection: "column", overflow: "hidden" },
      name: { fontSize: "13px", fontWeight: "700", color: "#1f2937", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
      metaRow: { display: "flex", alignItems: "center", gap: "4px", marginTop: "2px" },
      badge: { width: "14px", height: "14px", borderRadius: "50%", backgroundColor: "#10b981", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "9px", color: "#ffffff", fontWeight: "700" },
      num: { fontSize: "12px", color: "#9ca3af", fontWeight: "500" },
      bankName: { fontSize: "12px", color: "#138546", fontWeight: "600", marginTop: "2px" },
      alert: { display: "flex", alignItems: "center", gap: "8px", backgroundColor: "#fffdf0", border: "1px solid #f5ebd0", color: "#715c00", fontSize: "11px", padding: "8px 12px", borderRadius: "8px", marginBottom: "24px", textAlign: "left" },
      table: { borderTop: "1px solid #f3f4f6", paddingTop: "16px", display: "flex", flexDirection: "column", gap: "14px" },
      row: { display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "13px" },
      lblSub: { color: "#9ca3af", fontWeight: "500" },
      valSub: { fontWeight: "600", color: "#1f2937" },
      valDate: { fontWeight: "500", color: "#374151" }
    };

    let itemTranfer = dataTranfer?.data_tranfer;
    let itemData = dataTranfer?.data;

    let fromName = itemTranfer?.fromAccountName;
    let fromNo = itemTranfer?.fromAccountNoMasking;

    const isRecipient = FormatDataCustomerJson(itemData?.bank || null);
    let recipientName = itemTranfer?.beneficiaryName;
    let recipientNo = itemTranfer?.beneficiaryNoMasking;
    let recipientBank = isRecipient?.bankCode || "N/A";

    let fee = parseFloat(itemData?.fee) || 0.00;
    let isAmount = parseFloat(itemTranfer?.amount) || 0.00;

    let created_at = itemTranfer?.createDate
      ? moment(itemTranfer?.createDate).locale(dFormat).format("ll")
      : "N/A";

    // 🛠️ แก้ไขบั๊ก Typo จากจุดนี้ให้ดึงข้อมูลจาก itemData ได้ถูกต้องแม่นยำ
    let createdAt = itemData?.created_at
      ? moment(itemData?.created_at).locale(dFormat).format("lll")
      : "N/A";

    const toName = recipientName;
    const toBank = t(recipientBank);
    const toNo = recipientNo;
    const amount = isAmount;
    const transactionDate = created_at;
    const creator = fromName;

    return (
      <div style={styles.container}>
        <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end", marginBottom: 15, flexDirection: "column" }}>
          <small className="d-block fs-11" style={{color: "#888"}}>{t("transactionDate")}</small>
          <p style={{ ...styles.notifyText, marginBottom: 0, color: "#7a7b7d", fontSize: "13px" }}>
            {createdAt}
          </p>
        </div>

        <div style={{ display: "flex", alignItems: "center", marginBottom: "16px", flexDirection: "column" }}>
          <p style={styles.notifyText}>
            {t("notificationSent")}<br />
            {t("pleaseOpenKBiz")}
          </p>

          <div style={styles.iconWrapper}>
            <Image
              src={KBizPhoneIcon}
              alt="K BIZ Notification"
              preview={false}
              style={{ width: "120px", height: "auto" }}
              fallback="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' viewBox='0 0 24 24' fill='none' stroke='%2339a96b' stroke-width='1.5'><rect x='5' y='2' width='14' height='20' rx='2'/><path d='M12 18h.01'/><circle cx='15' cy='10' r='3'/></svg>"
            />
          </div>

          <div className="mt-3" style={styles.countdownText}>
            {secondsLeft > 0 ? (
              <>
                {t("pleaseCompleteWithin")} <span style={{ fontSize: "12px",  }}>{this.formatTime(secondsLeft)}</span> {t("minutes")}
              </>
            ) : (
              t("sessionExpired")
            )}
          </div>
        </div>

        <div style={styles.grid}>
          <div style={styles.col}>
            <span style={styles.label}>{t("from")}:</span>
            <div style={styles.card}>
              <div style={styles.avatarFrom}><BankOutlined /></div>
              <div style={styles.infoBox}>
                <span style={styles.name}>{fromName}</span>
                <div style={styles.metaRow}>
                  <span style={styles.badge}>
                    <Avatar size={14} src={BankData?.find((i) => i.bankCode === "004")?.bankLogo} />
                  </span>
                  <span style={styles.num}>{fromNo}</span>
                </div>
              </div>
            </div>
          </div>

          <div style={styles.col}>
            <span style={styles.label}>{t("to")}:</span>
            <div style={styles.card}>
              <Avatar style={styles.avatarTo} size={44} src={BankData?.find((i) => i.bank_id === recipientBank || i.bankCode === recipientBank)?.bankLogo} />
              <div style={styles.infoBox}>
                <span style={styles.name}>{toName}</span>
                <span style={styles.bankName}>{toBank}</span>
                <span style={styles.num}>{toNo}</span>
              </div>
            </div>
          </div>
        </div>

        {/* 🛠️ แก้ไขสไตล์ตรงนี้จาก fontMedium เป็น fontWeight */}
        <div style={styles.alert}>
          <InfoCircleFilled style={{ color: "#f59e0b", fontSize: "12px", flexShrink: 0 }} />
          <span style={{ fontWeight: "500" }}>
            {t("securityWarning")}
          </span>
        </div>

        <div style={styles.table}>
          <div style={styles.row}>
            <span style={styles.lblSub}>{t("amount")}</span>
            <span style={styles.valSub}>
              {amount.toFixed(2)} {t("baht")}
            </span>
          </div>

          <div className="d-none" style={styles.row}>
            <span style={styles.lblSub}>{t("fee")}</span>
            <span style={styles.valSub}>
              {fee.toFixed(2)} {t("baht")}
            </span>
          </div>

          <div style={styles.row}>
            <span style={styles.lblSub}>{t("accountDeductionDate")}</span>
            <span style={styles.valDate}>{transactionDate}</span>
          </div>

          <div style={styles.row}>
            <div style={{ display: "flex", flexDirection: "column", textAlign: "left" }}>
              <span style={styles.lblSub}>{t("accountReceivingDate")}</span>
              <span style={{ fontSize: "11px", color: "#9ca3af", fontWeight: "400" }}>
                ({t("instantTransferEffect")})
              </span>
            </div>
            <span style={styles.valDate}>{transactionDate}</span>
          </div>

          <div style={{ ...styles.row, paddingTop: "4px" }}>
            <span style={styles.lblSub}>{t("creator")}</span>
            <span style={styles.valDate}>{creator}</span>
          </div>
        </div>
      </div>
    );
  }
}

TransferManual.propTypes = {
  dataTranfer: PropTypes.shape({
    data: PropTypes.object,
    data_tranfer: PropTypes.object,
  }),
  t: PropTypes.func.isRequired,
  dFormat: PropTypes.string,
  rejectedManual: PropTypes.func,
  dataMember: PropTypes.object,
};